var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tes-td',{attrs:{"props":_vm.props}},[(_vm.props.value)?_c('date-tooltipped',{attrs:{"has-icon":false,"iso-date":_vm.props.value}}):_c('span',[_vm._v("ندارد")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }